import { connect } from "react-redux";

import _ from "lodash";
//import moment from 'moment'

import React from "react";

import {
  Card,
  List,
  Modal,
  Header,
  Segment,
  Dimmer,
  Loader
} from "semantic-ui-react";

import { fetchDetailData } from "../Actions/DashboardActions";
const maxPreviewSize = 5;
const reporterListSectionFields = [
  {
    field: "FIRST_NAME",
    title: "First Name",
    format: item => {
      return item;
    }
  },
  {
    field: "LAST_NAME",
    title: "Last Name",
    format: item => {
      return item;
    }
  },
  {
    field: "PHONE_NO",
    title: "Phone Number",
    format: item => {
      return item;
    }
  },
  {
    field: "EMAIL_ID",
    title: "Email",
    format: item => {
      return item;
    }
  },
  {
    field: "DEPARTMENT",
    title: "Department",
    format: item => {
      return item;
    }
  },
  {
    field: "HOSP_NAME",
    title: "Hospital",
    format: item => {
      return item;
    }
  },
  {
    field: "STATE",
    title: "State/Province/Region",
    format: item => {
      return item;
    }
  },
  {
    field: "CITY",
    title: "City",
    format: item => {
      return item;
    }
  },
  {
    field: "COUNTRY",
    title: "Country",
    format: item => {
      return item;
    }
  },
  {
    field: "POSTAL_CODE",
    title: "Postal Code",
    format: item => {
      return item;
    }
  }
];

class ReporterDetailView extends React.Component {
  state = { modalOpen: false };

  handleOpen = () => {
    this.props.fetchDetailData();
    this.setState({ modalOpen: true });
  };

  handleClose = () => {
    this.setState({ modalOpen: false });
  };

  render() {
    const noReportersView = <div>No Reporters For This Case</div>;

    const reporterCards = (
      <Card.Group>
        {_.map(this.props.reporter_detail, (reporter, idx) => {
          let reporterListSection;
          const reporterListSectionIsDefined = _.some(
            reporterListSectionFields,
            section => {
              return (
                !_.isUndefined(reporter[section.field]) &&
                reporter[section.field] !== null
              );
            }
          );
          if (reporterListSectionIsDefined) {
            reporterListSection = (
              <Card.Content>
                <List>
                  {_.reduce(
                    reporterListSectionFields,
                    (result, section, idx) => {
                      if (
                        !_.isUndefined(reporter[section.field]) &&
                        reporter[section.field] !== null
                      ) {
                        result.push(
                          <List.Item key={idx}>
                            <List.Header>{section.title}</List.Header>
                            {section.format(reporter[section.field])}
                          </List.Item>
                        );
                      }
                      return result;
                    },
                    []
                  )}
                </List>
              </Card.Content>
            );
          }

          return (
            <Card fluid key={idx}>
              {reporterListSection}
            </Card>
          );
        })}
      </Card.Group>
    );

    const reporters = _.compact(_.map(this.props.reporters, _.trim));
    const hasReporterDataButMissingNames = (this.props.reporters || []).length > 0 && (reporters || []).length === 0;
    const modalTrigger = hasReporterDataButMissingNames ? (
      <a>
        <div style={{ cursor: "pointer" }} onClick={this.handleOpen} title={'View Reporter Details'}>
          View Reporter Details
        </div>
      </a>
    ) : 
    (
      <a>
        <div style={{ cursor: "pointer" }} onClick={this.handleOpen} title={reporters.join(', ')}>
          {(reporters.slice(0, maxPreviewSize) || []).join(", ")}
          {reporters.length > maxPreviewSize ? "..." : ""}
        </div>
      </a>
    );

    return (
      <Modal
        trigger={modalTrigger}
        open={this.state.modalOpen}
        onClose={this.handleClose}
        size="small"
      >
        <Header content="Reporters" />
        <Modal.Content scrolling>
          {this.props.fetching_reporter_detail && (
            <Segment style={{ height: "50vh" }}>
              <Dimmer active>
                <Loader>Loading</Loader>
              </Dimmer>
            </Segment>
          )}
          {!this.props.fetching_reporter_detail &&
            (this.props.reporter_detail.length > 0
              ? reporterCards
              : noReportersView)}
        </Modal.Content>
      </Modal>
    );
  }
}

//Binds the current Redux state to props that the sub component (DashboardView) uses
const mapStateToProps = (state, ownProps) => {
  return {
    reporter_detail: _.get(state, "dashboard.reporter_detail") || [],
    fetching_reporter_detail:
      _.get(state, "dashboard.fetching_reporter_detail") || false
  };
};

//map actions to properties to allow subcomponents tp update state
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchDetailData: () => {
      dispatch(fetchDetailData(ownProps.record_id, "reporter_detail"));
    }
  };
};

//Boilerplate code to connect the subcomponent to the Redux state - automatically determines if the subcomponent should update when the state is updated
export const ReporterDetail = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReporterDetailView);

export default ReporterDetail;



// WEBPACK FOOTER //
// ./src/Components/ReporterDetail.jsx